import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons";
import theme from "@theme";

const MenuIcon = styled(InnoIcons.RightArrow)`
  background-color: ${theme.colors.themeColor};
  border-radius: 12px;
  color: white;
  cursor: pointer;
  padding: 3px;
`;
const leftIcon = styled(InnoIcons.LeftArrow)`
  background-color: ${theme.colors.themeColor};
  border-radius: 12px;
  color: white;
  cursor: pointer;
  padding: 3px;
`;

const SC = {
  MenuIcon,
  leftIcon,
};

export default SC;
